import { render, staticRenderFns } from "./NavbarNavReleaseNotesButton.vue?vue&type=template&id=a6a96df0&scoped=true&"
import script from "./NavbarNavReleaseNotesButton.vue?vue&type=script&lang=js&"
export * from "./NavbarNavReleaseNotesButton.vue?vue&type=script&lang=js&"
import style0 from "./NavbarNavReleaseNotesButton.vue?vue&type=style&index=0&id=a6a96df0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a96df0",
  null
  
)

export default component.exports